export enum DashboardSidebarElements {
  MyApplication = 'My Application',
  LoanDetails = 'Loan Details',
  FAQs = "FAQ's",
  AccountSettings = 'Account Settings',
}
